import { useEffect, useState } from 'react';
import { Table, Button, Modal, Form, Input, DatePicker, Select, Tag, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { FAOService } from '../api/services/fao.service';

export default function FAOPage() {
  const [plans, setPlans] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [form] = Form.useForm();

  const fetchPlans = () => FAOService.getPlans().then(r => setPlans(r.data)).catch(() => {});
  useEffect(() => { fetchPlans(); }, []);

  const handleCreate = async (values) => {
    await FAOService.createPlan({
      ...values,
      period_start: values.period_start.format('YYYY-MM-DD'),
      period_end: values.period_end.format('YYYY-MM-DD'),
    });
    message.success('Бюджетный план создан');
    setModalOpen(false);
    form.resetFields();
    fetchPlans();
  };

  const columns = [
    { title: 'Название', dataIndex: 'name', key: 'name' },
    { title: 'Тип', dataIndex: 'plan_type', key: 'type', render: (t) => <Tag>{t.toUpperCase()}</Tag> },
    { title: 'Период', key: 'period', render: (_, r) => `${r.period_start} - ${r.period_end}` },
    { title: 'Доход', dataIndex: 'total_income', key: 'income', render: (v) => `${v.toLocaleString()} руб.` },
    { title: 'Расход', dataIndex: 'total_expense', key: 'expense', render: (v) => `${v.toLocaleString()} руб.` },
    { title: 'Статус', dataIndex: 'status', key: 'status', render: (s) => <Tag color={s === 'draft' ? 'default' : 'green'}>{s}</Tag> },
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">ФАО</h1>
        <p className="page-subtitle">Финансовое планирование</p>
      </div>
      
      <Button type="primary" icon={<PlusOutlined />} onClick={() => setModalOpen(true)} style={{ marginBottom: 16, background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', border: 'none' }}>Новый план</Button>
      <Card style={{ borderRadius: 16 }} styles={{ body: { padding: 0 } }}>
        <Table dataSource={plans} columns={columns} rowKey="id" />
      </Card>

      <Modal title="Новый бюджетный план" open={modalOpen} onCancel={() => setModalOpen(false)} onOk={() => form.submit()} okText="Создать">
        <Form form={form} layout="vertical" onFinish={handleCreate}>
          <Form.Item name="name" label="Название" rules={[{ required: true }]}><Input /></Form.Item>
          <Form.Item name="plan_type" label="Тип" rules={[{ required: true }]}>
            <Select options={[{ value: 'bdds', label: 'БДДС' }, { value: 'bdr', label: 'БДР' }]} />
          </Form.Item>
          <Form.Item name="period_start" label="Начало периода" rules={[{ required: true }]}><DatePicker style={{ width: '100%' }} /></Form.Item>
          <Form.Item name="period_end" label="Конец периода" rules={[{ required: true }]}><DatePicker style={{ width: '100%' }} /></Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
